'use strict';

require('core-js/fn/array/from');

require('core-js/fn/array/iterator');

require('core-js/fn/array/find-index');

require('core-js/fn/map');

require('core-js/fn/string/starts-with');

require('core-js/fn/string/includes');

require('core-js/fn/symbol');


//////////////////
// WEBPACK FOOTER
// /home/deploy/gamba/shared/rnclient/node_modules/react-toolbox/lib/utils/polyfills.js
// module id = 2223
// module chunks = 4